import React from "react";
import { AppStateContext } from "../context/AppStateContext";
import { isLoading, loading } from "../Loading";
import { AgencyId } from "../messages";
import { isDefined } from "./Generic/IsDefined";

export function useMedflytAgencyId() {
  const appState = React.useContext(AppStateContext);

  if (!isDefined(appState) || isLoading(appState.appAgenciesState)) {
    return loading();
  }

  const agencyDetails = [...appState.appAgenciesState.agencies.values()].find(
    (x) => x.agency.isMedflytAgency
  );

  if (agencyDetails === undefined) {
    return loading();
  }

  return agencyDetails.agency.id;
}

export function withMedflytAgencyId<T extends { medflytAgencyId: AgencyId }>(
  Component: React.ComponentType<T>
) {
  const HOC = (props: Omit<T, "medflytAgencyId">): JSX.Element => {
    const appState = React.useContext(AppStateContext);

    if (!isDefined(appState) || isLoading(appState.appAgenciesState)) {
      return <></>;
    }

    const agencyDetails = [...appState.appAgenciesState.agencies.values()].find(
      (x) => x.agency.isMedflytAgency
    );

    if (agencyDetails === undefined) {
      return <></>;
    }

    const newProps = { ...props, medflytAgencyId: agencyDetails.agency.id } as unknown as T;

    return <Component {...newProps} />;
  };

  HOC.displayName = `withMedflytAgencyId(${Component.displayName ?? Component.name})`;

  return HOC;
}
